import { Link } from 'react-router-dom';
import speakerDefaultImg from '../../../utils/images/speaker-default.png';
import speaker1Img from '../../../utils/images/speaker_prof.png';
import speaker2Img from '../../../utils/images/speaker_femi.png';
import speaker3Img from '../../../utils/images/godwin.png';
import exploreIcon from '../../../utils/icons/explore-icon.png';


const SpeakersSection = () => {
  return (
    <section className='speakers_intro-section page-width px-3 my-5 py-5'>
        <h2 className="text-center text-uppercase pt-5 pb-3 my-5">Meet our speakers 8+</h2>

        <section className="speakers-profile row overflow-hidden">
            <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-left">
                <div className="profile-details">
                    <img src={speaker1Img} alt="profile pic" className='' />
                    <div className="profile-info">
                        <h3 className='custom-thunder'>Prof. Conrad Omonhinmin</h3>
                        <p className='custom-cosmos'>Director CUCRID Covenant University</p>
                    </div>
                </div>
            </div>
            <div className="col-md-4 col-sm-12 mb-5 js-scroll fade-in">
                <div className="profile-details">
                    <img src={speaker2Img} alt="profile pic" className='' />
                    <div className="profile-info">
                        <h3 className='custom-thunder'>APST. FEMI LAZARUS</h3>
                        <p className='custom-cosmos'>Founder of Light Nation</p>
                    </div>
                </div>
            </div>
            <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-right">
                <div className="profile-details">
                    <img src={speaker3Img} alt="profile pic" className='pt-5' />
                    <div className="profile-info">
                        <h3 className='custom-thunder'>GODWIN AIGBOVIODE OMAGE</h3>
                        <p className='custom-cosmos'>Founder, Co-Net technologies Ltd</p>
                    </div>
                </div>
            </div>
        </section>

        <section className='speaker_section-actionBtn js-scroll fade-in-bottom'>
            <a href='https://lu.ma/6pj6tk23' rel="noopener noreferrer"  target='_blank' className='customBtn-colored'> <span>REGISTER</span> <img src={exploreIcon} alt="" /></a>
            <Link to="/speakers" className='customBtn'> <span>SEE ALL SPEAKERS</span> <img src={exploreIcon} alt="" /></Link>
        </section>
    </section>
  )
}

export default SpeakersSection